export default __webpack_public_path__ + "static/media/icons8-putty-knife.2b6d1d79.svg";